import {useEffect, useState} from 'react';
import UploadImage from 'components/Startup/profile/companyImage';
import {isDev} from 'utils/constants';

/**
 * An image upload bound to a Form.Item.
 *
 * antd hands `value` and `onChange` to the child of a Form.Item, so this works
 * anywhere — including inside a Form.List, where per-row local state would
 * otherwise be needed. The stored value is the uploaded URL.
 *
 *   <Form.Item name={[name, 'logo']} label="Logo">
 *     <ImageUploadField label="Upload logo" />
 *   </Form.Item>
 */
export const ImageUploadField = ({
  value,
  onChange,
  label = 'Upload image',
  folder = 'bonds',
  large,
}) => {
  const [previewUrl, setPreviewUrl] = useState(value);

  // Keep the preview in step when the form is populated programmatically.
  useEffect(() => setPreviewUrl(value), [value]);

  return (
    <UploadImage
      label={label}
      isACL
      large={large}
      folder={folder}
      previewUrl={previewUrl}
      setPreviewUrl={setPreviewUrl}
      setImgUrl={url => onChange?.(url)}
      bucket={
        isDev
          ? 'dabafinancialinstruments-nonprod'
          : 'dabafinancialinstruments-prod'
      }
    />
  );
};

export default ImageUploadField;
